import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lister-type"
// Controls lister type selection UI with conditional section display
//
// Targets:
//   - radio: Radio button inputs for lister type
//   - card: Card container for visual selection state
//   - section: Section to show/hide based on selected type
//
// Usage:
//   <div data-controller="lister-type">
//     <input type="radio" data-lister-type-target="radio" data-action="change->lister-type#toggle">
//     <div data-lister-type-target="card" data-type="broker">...</div>
//     <div data-lister-type-target="section" data-type="broker">...</div>
//   </div>
export default class extends Controller {
  static targets = ["radio", "card", "section"]

  connect() {
    // Initialize based on current selection
    this.updateUI()
  }

  toggle(event) {
    this.updateUI()
  }

  // Update honorific selection visual state
  updateHonorific(event) {
    const container = event.target.closest('.flex.gap-3')
    if (!container) return

    // Reset all honorific labels
    container.querySelectorAll('label > div').forEach(div => {
      div.classList.remove('border-crust-600', 'bg-crust-50')
      div.classList.add('border-charcoal-200')
    })

    // Highlight selected option
    const selectedDiv = event.target.closest('label')?.querySelector('div')
    if (selectedDiv) {
      selectedDiv.classList.remove('border-charcoal-200')
      selectedDiv.classList.add('border-crust-600', 'bg-crust-50')
    }
  }

  updateUI() {
    // Find selected radio
    const selectedRadio = this.radioTargets.find(radio => radio.checked)
    const selectedType = selectedRadio?.value || null

    // Update card visual states
    this.cardTargets.forEach(card => {
      const cardType = card.dataset.type
      const isSelected = cardType === selectedType

      // Reset classes
      card.classList.remove(
        "border-blue-600", "bg-blue-50", "hover:border-blue-300",
        "border-green-600", "bg-green-50", "hover:border-green-300",
        "border-charcoal-200"
      )

      // Apply appropriate classes based on type
      if (isSelected) {
        if (cardType === "broker") {
          card.classList.add("border-blue-600", "bg-blue-50")
        } else if (cardType === "owner") {
          card.classList.add("border-green-600", "bg-green-50")
        }
      } else {
        card.classList.add("border-charcoal-200")
        if (cardType === "broker") {
          card.classList.add("hover:border-blue-300")
        } else if (cardType === "owner") {
          card.classList.add("hover:border-green-300")
        }
      }
    })

    // Update section visibility
    this.sectionTargets.forEach(section => {
      const sectionType = section.dataset.type
      const shouldShow = sectionType === selectedType

      if (shouldShow) {
        section.classList.remove("hidden")
      } else {
        section.classList.add("hidden")
      }
    })
  }
}
